import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mt-5" }
const _hoisted_2 = { class: "p-4 pb-0" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = { class: "table table-striped" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { colspan: "2" }
const _hoisted_13 = {
  key: 0,
  class: "mt-4 pt-2"
}
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-sm-3" }
const _hoisted_16 = { class: "col-sm-3" }
const _hoisted_17 = { class: "col-sm-3" }
const _hoisted_18 = { class: "col-sm-3" }
const _hoisted_19 = {
  key: 1,
  class: "table table-striped mt-2"
}
const _hoisted_20 = { class: "total" }
const _hoisted_21 = { class: "py-2" }
const _hoisted_22 = { class: "py-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_localized_text, {
      type: "h3",
      localizedKey: "Mechanical Embroidery",
      text: "Mechanical Embroidery"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          type: "label",
          localizedKey: "Do you have a mechanical embroidery?",
          text: "Do you have a mechanical embroidery?"
        }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn me-1", _ctx.haveMechanicalEmbroidery ? 'btn-secondary' : 'btn-tertiary']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeEmbroiderySection())),
            disabled: _ctx.isReadOnly
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "No",
              text: "No"
            })
          ], 10, _hoisted_5),
          _createElementVNode("button", {
            class: _normalizeClass(["btn ms-1", _ctx.haveMechanicalEmbroidery ? 'btn-tertiary' : 'btn-secondary']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.haveMechanicalEmbroidery = true)),
            disabled: _ctx.isReadOnly
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Yes",
              text: "Yes"
            })
          ], 10, _hoisted_6)
        ])
      ]),
      (_ctx.haveMechanicalEmbroidery)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_localized_text, {
                type: "h5",
                localizedKey: "Materials",
                text: "Materials",
                class: "mb-0"
              }),
              (!_ctx.isReadOnly)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-secondary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editMaterialsComposition()))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Edit composition",
                      text: "Edit composition"
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_9,
            _createElementVNode("table", _hoisted_10, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Material",
                      text: "Material"
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Percentage",
                      text: "Percentage"
                    })
                  ])
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.mechanicalEmbroidery.materialsPercentage.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                      _createElementVNode("td", _hoisted_12, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "No Elements Found",
                          text: "No Elements Found"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mechanicalEmbroidery.materialsPercentage, (materialPercentage, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(materialPercentage.key), 1),
                    _createElementVNode("td", null, _toDisplayString(materialPercentage.value) + " %", 1)
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.mechanicalEmbroidery.materialsPercentage.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_form_field, {
                        type: "number",
                        labelKey: "Thread density (g/m)",
                        labelValue: "Thread density (g/m)",
                        placeholderKey: "Thread density (g/m)",
                        placeholderValue: "Thread density (g/m)",
                        readonly: _ctx.isReadOnly,
                        modelValue: _ctx.mechanicalEmbroidery.threadDensity,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mechanicalEmbroidery.threadDensity) = $event)),
                        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateValue()))
                      }, null, 8, ["readonly", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_form_field, {
                        type: "number",
                        labelKey: "Thread length (cm)",
                        labelValue: "Thread length (cm)",
                        placeholderKey: "Thread length (cm)",
                        placeholderValue: "Thread length (cm)",
                        readonly: _ctx.isReadOnly,
                        modelValue: _ctx.mechanicalEmbroidery.threadLength,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.mechanicalEmbroidery.threadLength) = $event)),
                        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateValue()))
                      }, null, 8, ["readonly", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_form_field, {
                        type: "number",
                        labelKey: "Machine (watt)",
                        labelValue: "Machine (watt)",
                        placeholderKey: "Machine (watt)",
                        placeholderValue: "Machine (watt)",
                        readonly: _ctx.isReadOnly,
                        modelValue: _ctx.mechanicalEmbroidery.machineWatt,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.mechanicalEmbroidery.machineWatt) = $event)),
                        onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateValue()))
                      }, null, 8, ["readonly", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_form_field, {
                        type: "number",
                        labelKey: "Machine run time (sec)",
                        labelValue: "Machine run time (sec)",
                        placeholderKey: "Machine run time (sec)",
                        placeholderValue: "Machine run time (sec)",
                        readonly: _ctx.isReadOnly,
                        modelValue: _ctx.mechanicalEmbroidery.machineRunTime,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.mechanicalEmbroidery.machineRunTime) = $event)),
                        onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateValue()))
                      }, null, 8, ["readonly", "modelValue"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.mechanicalEmbroidery.materialsPercentage.length > 0)
              ? (_openBlock(), _createElementBlock("table", _hoisted_19, [
                  _createElementVNode("tr", _hoisted_20, [
                    _createElementVNode("td", _hoisted_21, [
                      _createElementVNode("strong", null, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Total",
                          text: "Total"
                        })
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_22, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.approximation(_ctx.getTotal)) + " gCO2e", 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}